import { render, staticRenderFns } from "./CourseDetails.vue?vue&type=template&id=1d744c24&scoped=true"
import script from "./CourseDetails.vue?vue&type=script&lang=js"
export * from "./CourseDetails.vue?vue&type=script&lang=js"
import style0 from "./CourseDetails.vue?vue&type=style&index=0&id=1d744c24&prod&scoped=true&lang=css"
import style1 from "./CourseDetails.vue?vue&type=style&index=1&id=1d744c24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d744c24",
  null
  
)

export default component.exports